import { SettingOutlined } from "@ant-design/icons";
import { Input, Typography } from "antd";
import { Wrapper as WrapperBase } from "pages/fulfillment/FulfillmentProductCreatePage/ProductInfo/ProductInfo.styles";
import styled from "styled-components";

export const Wrapper = styled(WrapperBase)`
  h4 {
    margin-bottom: 0;
  }

  .ant-input-number-disabled {
    background-color: transparent;
  }
`;

export const Title = styled(Typography.Title)`
  h4 {
    margin-bottom: 0;
  }
`;

export const Search = styled(Input.Search)`
  max-width: 300px;
  .ant-input-affix-wrapper {
    height: 32px;
  }
  input {
    font-size: 14px !important;
  }
`;

export const SettingOptions = styled(SettingOutlined)`
  font-size: 16px;
  color: black;
`;
